export default __webpack_public_path__ + "static/media/ruler.375474bb.svg";